import React, {useState} from 'react';
import {connect} from 'react-redux';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import {PortalSettingsGetSchema} from '../../../../api/DBSchema/PortalSettings';
import SMCNumberInput from '../../../../components/Simple/SMCNumberInput';
import RowLayout from '../../../../components/Layouts/RowLayout';
import {SMCCheckbox} from '../../../../components/Simple/SMCCheckbox';
import {TemplateSchema} from '../../../../api/DBSchema/Template';
import SMCLabel from '../../../../components/Simple/SMCLabel';
import SMCButton from '../../../../components/Simple/SMCButton';
import {SMCSelect, SMCOption} from '../../../../components/Simple/SMCSelect';
import {Tooltip} from '@mui/material';
import helpIcon from '../../../../assets/images/help_normal.png'
import TemplateEditorModal from '../../../PopupPages/TemplateEditors/TemplateEditorModal';
import SMCIcon from '../../../../components/Simple/SMCIcon';
import {isUserAdminSelector} from '../../../../store/selectors/user.selectors';

const pageSchema = PortalSettingsGetSchema.pages.notificationGateways;
const pageId = pageSchema.pageId;

function PortalSettingsGatewayNotifications({
    portalSettingsObject,
    setPortalSettingsData,
    isUserAdmin
}) {
    const { t } = useTranslation();

    const pageData = portalSettingsObject[pageId];

    const gatewayAddedOrChanged     = pageData[pageSchema.gatewayAddedOrChanged];
    const gatewayNotConnected       = pageData[pageSchema.gatewayNotConnected];

    const gatewayNotConnectedSchema = pageSchema.gatewayNotConnectedSchema;

    const [isGatewayAddedOrChangedCustomizeOpen, setIsGatewayAddedOrChangedCustomizeOpen] = useState(false);
    const [isGatewayNotConnectedCustomizeOpen, setIsGatewayNotConnectedCustomizeOpen] = useState(false);

    return (
        <EditorLayout>
            <RowLayout spacing="4px">
                <span style={{ width: 450 }}>
                    <SMCCheckbox
                        checked={gatewayAddedOrChanged[TemplateSchema.enabled]}
                        onChange={e => setPortalSettingsData([pageId, pageSchema.gatewayAddedOrChanged, TemplateSchema.enabled], e.target.checked)}
                        label={t('SMC_SETTINGS_NOTIFY_GATEWAY_ADDCHANGE')}
                    />
                </span>
                <span style={{ width: 310 }} />
                <SMCButton onClick={() => setIsGatewayAddedOrChangedCustomizeOpen(true)}>
                    <RowLayout spacing="4px"><SMCIcon icon="rightArrow" />{t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.CUSTOMIZE')}</RowLayout>
                </SMCButton>
            </RowLayout>
            <RowLayout spacing="4px">
                <span style={{ width: 450 }}>
                    <SMCCheckbox
                        checked={gatewayNotConnected[TemplateSchema.enabled]}
                        onChange={e => setPortalSettingsData([pageId, pageSchema.gatewayNotConnected, TemplateSchema.enabled], e.target.checked)}
                        label={t('SMP.SETTINGS.NOTIFICATIONS.GATEWAYS.LINE2')}
                    />
                </span>
                <RowLayout spacing="4px" style={{ width: 310 }}>
                    {
                        gatewayNotConnected[gatewayNotConnectedSchema.gatewayNotConnectedIsMins] && (
                            <SMCNumberInput
                                value={gatewayNotConnected[gatewayNotConnectedSchema.gatewayNotConnectedMins]}
                                onChange={e => setPortalSettingsData([pageId, pageSchema.gatewayNotConnected, gatewayNotConnectedSchema.gatewayNotConnectedMins], parseInt(e.target.value))}
                                width={50}
                            />
                        )
                    }
                    {
                        !gatewayNotConnected[gatewayNotConnectedSchema.gatewayNotConnectedIsMins] && (
                            <SMCNumberInput
                                value={gatewayNotConnected[gatewayNotConnectedSchema.gatewayNotConnectedDays]}
                                onChange={e => setPortalSettingsData([pageId, pageSchema.gatewayNotConnected, gatewayNotConnectedSchema.gatewayNotConnectedDays], parseInt(e.target.value))}
                                width={50}
                            />
                        )
                    }
                    <SMCSelect
                        value={gatewayNotConnected[gatewayNotConnectedSchema.gatewayNotConnectedIsMins] ? 'MINUTES' : 'DAYS'}
                        onChange={e => setPortalSettingsData([pageId, pageSchema.gatewayNotConnected, gatewayNotConnectedSchema.gatewayNotConnectedIsMins], e.target.value === 'MINUTES')}
                        width={100}
                    >
                        <SMCOption value="MINUTES">{t('SMP.SETTINGS.NOTIFICATIONS.GATEWAYS.MINUTES')}</SMCOption>
                        <SMCOption value="DAYS">{t('SMP.SETTINGS.NOTIFICATIONS.GATEWAYS.DAYS')}</SMCOption>
                    </SMCSelect>
                    {
                        !gatewayNotConnected[gatewayNotConnectedSchema.gatewayNotConnectedIsMins] && (
                            <SMCLabel>at</SMCLabel>
                        )
                    }
                    {
                        !gatewayNotConnected[gatewayNotConnectedSchema.gatewayNotConnectedIsMins] && (
                            <SMCSelect
                                value={gatewayNotConnected[gatewayNotConnectedSchema.gatewayNotConnectedAtHour]}
                                onChange={e => setPortalSettingsData([pageId, pageSchema.gatewayNotConnected, gatewayNotConnectedSchema.gatewayNotConnectedAtHour], e.target.value)}
                                width={110}
                            >
                                {
                                    // Options of 00:00-01:00 until 23:00-24:00
                                    [...Array(24)].map((o, i) => (
                                        <SMCOption value={i} key={i}>{i<10&&0}{i}:00-{(i+1)<10&&0}{i+1}:00</SMCOption>
                                    ))
                                }
                            </SMCSelect>
                        )
                    }
                </RowLayout>
                <SMCButton onClick={() => setIsGatewayNotConnectedCustomizeOpen(true)}>
                    <RowLayout spacing="4px"><SMCIcon icon="rightArrow" />{t('SMP.SYSTEM.SETTINGS.NOTIFICATIONS.CUSTOMIZE')}</RowLayout>
                </SMCButton>
                <Tooltip title={t('SMP.SETTINGS.NOTIFICATIONS.GATEWAYS.LINE2.TOOLTIP')}><img src={helpIcon} alt="help" /></Tooltip>
            </RowLayout>
            
            {/* Popup windows */}
            <TemplateEditorModal
                isOpen={isGatewayAddedOrChangedCustomizeOpen}
                onRequestClose={() => setIsGatewayAddedOrChangedCustomizeOpen(false)}
                defaultObject={gatewayAddedOrChanged}
                onSuccess={val => {
                    setPortalSettingsData([pageId, pageSchema.gatewayAddedOrChanged], val);
                    setIsGatewayAddedOrChangedCustomizeOpen(false);
                }}
                templateName={pageSchema.gatewayAddedOrChanged}
                hasAdministratorsTab={isUserAdmin}
            />
            <TemplateEditorModal
                isOpen={isGatewayNotConnectedCustomizeOpen}
                onRequestClose={() => setIsGatewayNotConnectedCustomizeOpen(false)}
                defaultObject={gatewayNotConnected}
                onSuccess={val => {
                    setPortalSettingsData([pageId, pageSchema.gatewayNotConnected], val)
                    setIsGatewayNotConnectedCustomizeOpen(false);
                }}
                templateName={pageSchema.gatewayNotConnected}
                hasAdministratorsTab={isUserAdmin}
            />
        </EditorLayout>
    )
}

const mapStateToProps = state => ({
    isUserAdmin: isUserAdminSelector(state)
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(PortalSettingsGatewayNotifications);